
import { useState, useEffect } from "react";
import { Card } from "@/components/ui/card";
import { Star } from "lucide-react";
import { useAdminSettings } from "@/hooks/useAdminSettings";

const Testimonials = () => {
  const { settings } = useAdminSettings();

  if (!settings.show_reviews) {
    return null;
  }

  return (
    <section className="section-gap-top" style={{ backgroundColor: 'rgba(27, 33, 57, 0.95)' }}>
      <div className="container mx-auto px-4">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-[#F4F4F4] mb-6">
            {settings.reviews_title}
          </h2>
          <p className="text-[#F4F4F4] text-sm md:text-base">
            {settings.reviews_subtitle}
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-4 md:gap-8 max-w-6xl mx-auto">
          {settings.testimonials.map((testimonial, index) => (
            <Card key={index} className="p-4 md:p-6 border border-[#364264] shadow-sm hover:shadow-md transition-shadow" style={{ backgroundColor: '#364264' }}>
              <div className="flex items-center mb-3 md:mb-4">
                <img 
                  src={testimonial.image} 
                  alt={testimonial.name}
                  className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover mr-3 md:mr-4"
                />
                <div>
                  <h4 className="font-bold text-[#F3B340] text-sm md:text-base">{testimonial.name}</h4>
                  <p className="text-[#F4F4F4] text-xs md:text-sm">{testimonial.role}</p>
                </div>
              </div>
              
              <div className="flex mb-2 md:mb-3">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-3 h-3 md:w-4 md:h-4 fill-[#D9992B] text-[#D9992B]" />
                ))}
              </div>
              
              <p className="text-[#F4F4F4] text-xs md:text-sm leading-relaxed">{testimonial.content}</p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
